/* Spiritual Life School – tema yardımcı betiği.
   Harici kütüphane kullanmaz, Dawn bileşenleriyle çakışmaz. */
(function () {
  'use strict';

  function init() {
    // Dış bağlantılar için güvenlik: target=_blank olanlara rel ekle.
    document.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var rel = (link.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
      link.setAttribute('rel', rel.join(' '));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
